import { FC, useContext, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { RequestDateOfTreatmentProps, RequestTreatmentNotTreatingApiResponse } from "../requestDateOfTreatment/types";
import { NOT_TREATING_REASON } from "src/constants/cases";
import { useNavigate } from "react-router-dom";
import { isNotKAMUser } from "src/helpers";
import { AuthContext } from "src/context/authContext";




const CancelTreatment: FC<RequestDateOfTreatmentProps> = ({ isModalVisible, caseId, hideModal, prescriptionId, refreshListing }): JSX.Element => {
  const [allReasons, setAllReasons] = useState<{ value: string; label: string; }[]>(NOT_TREATING_REASON[0].subReasons);
  const [cancelCategory, setCancelCategory] = useState<string>(NOT_TREATING_REASON[0].label);
  const [cancelReason, setCancelReason] = useState<string>();
  const { userData } = useContext(AuthContext)

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (allReasons.length > 0) {
      setCancelReason(allReasons[0].value)
    }
  }, [allReasons]);

  const getValue = () => {
    if (allReasons.length > 0) {
      const data = allReasons.find((option) => option.value === cancelReason);
      if (data) return data as unknown as PropsValue<string>;
    }
  };

  const onChangeSelect = (value: SingleValue<string>) => {
    setCancelReason((value as unknown as { value: string; label: string; }).value);
  };

  // Category related handling
  const getValueForCategory = () => {
    const data = NOT_TREATING_REASON.find((option) => option.value === cancelCategory);
    if (data) return data as unknown as PropsValue<string>;
  };

  const onChangeCategory = (value: SingleValue<string>) => {
    const selectedValue = (value as unknown as { value: string; label: string; }).value
    setCancelCategory(selectedValue);
    const data = NOT_TREATING_REASON.find((item) => item.value === selectedValue);
    if (data && data.subReasons.length > 0) { setCancelReason(""); setAllReasons(data.subReasons)}
    if (data && data.subReasons.length === 0 && allReasons.length > 0) {
      setCancelReason("")
      setAllReasons([]);
    }
  };

  const { data: caseInsurances, mutate: getCaseInsurances } = 
    useFetch<{ insurance_name: string; is_primary: boolean; plan_type: string; }[]>(APIEndpoints.FETCH_CASE_INSURANCES, {}, { caseId }, false);

  useEffect(() => {
    if (caseId !== 0) getCaseInsurances({}, { caseId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId])




  const { loading: treatmentReqLoader, data: requestTreatmentData, mutate: updateRequestTreatment, error: treatmentUpdateError } = 
    useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.REQUEST_TREATMENT_NOT_TREATING, {}, { caseId, prescriptionId })

  const saveTreatmentReason = () => {
    const requestBody = {
      prescription: {
        bentype: "non",
        status_reason: cancelReason || cancelCategory
      }
    }
    updateRequestTreatment(requestBody)
  };

  useEffect(() => {
    if (requestTreatmentData || treatmentUpdateError) {
      setAllReasons(NOT_TREATING_REASON[0].subReasons);
      setCancelCategory(NOT_TREATING_REASON[0].value);
      setCancelReason('');
      hideModal()
    }
    if (requestTreatmentData) {
      const { code } = requestTreatmentData;
      if (code === 200) {
        showToast([`Request Treatment Scheduled Successfully`], ToastTypes.SUCCESS);
        ((userData && isNotKAMUser(userData.ref_type)) ? refreshListing() : navigate(0))
        // navigate(0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestTreatmentData, treatmentUpdateError]);



  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <form onSubmit={saveTreatmentReason}>
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title" style={{color:'#008853',fontSize:'1.875rem'}}>
                Non-treatment Reason for Case {caseId}
              </p>
              <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
            </div>

            <div className="modal-body">
              <p className="text-center"> Please specify reason for non-treatment...</p>

              <div className="row align-items-center justify-content-start">
                <div className="col-md-6 col-12">
                  <label htmlFor="cancelTreatmentCategory" className="form-label justify-content-start mb-1">Status Category *</label>
                  <Select
                    options={NOT_TREATING_REASON as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="cancelTreatmentCategory"
                    isSearchable={false}
                    noOptionsMessage={() => "Select Option..."}
                    value={getValueForCategory()}
                    onChange={(value) => onChangeCategory(value)}
                    defaultValue={NOT_TREATING_REASON[0].label}
                  />
                </div>
                {allReasons.length > 0 && (
                  <div className="col-md-6 col-12">
                    <label htmlFor="cancelTreatment" className="form-label justify-content-start mb-1"> Status Reason *</label>
                    <Select
                      options={allReasons as unknown as OptionsOrGroups<string, GroupBase<string>>}
                      id="cancelTreatment"
                      isSearchable={false}
                      noOptionsMessage={() => "Select Option..."}
                      value={getValue()}
                      onChange={(value) => onChangeSelect(value)}
                    />
                  </div>
                )}
              </div>

              {cancelCategory === "HCP Decided Not To Treat" && 
                cancelReason === "Cost to Patient" && 
                caseInsurances?.length === 1 &&
                caseInsurances?.some((insurance) => insurance.plan_type?.toLowerCase()?.includes("commercial")) ? (
                <div className="alert alert-warning mt-3">
                  <span style={{ fontSize: 14 }}>
                    Patient could be eligible for cost savings based on their plan type. Please 
                    visit 
                    <a className="px-1" href="https://www.qutenza.com/save-on-qutenza-treatment/" target="_blank" rel="noreferrer">
                      QUTENZA (Capsaicin) | Financial Support
                    </a>
                    for more details. Are you sure you want to save this 'Not Treated' status?
                  </span>
                </div>
              ) : null}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-blue"
                data-bs-dismiss="modal"
                onClick={saveTreatmentReason}
                disabled={treatmentReqLoader}
              >
                {treatmentReqLoader ? (<i className="spinner-border me-2"></i>) : null}
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelTreatment;